import { Entity } from '@backstage/catalog-model';

export const GENAI_SUBSCRIPTION_ANNOTATION = 'zeiss.com/genai-platform-api-keys-subscription';

export function isGenaiSystem(entity: Entity): boolean {
  return (
    entity?.metadata?.annotations?.[GENAI_SUBSCRIPTION_ANNOTATION] === 'true'
  );
}